import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from '../messages';
import styles from './styles.module.less';

type ProductColumnProps = {
  openProductDetails: (productId: number) => void;
  data: Record<string, unknown>;
};

export const ProductColumn = ({ openProductDetails, data }: ProductColumnProps) => {
  const productId = data.productId as number;
  const name = data.name as string | null;
  const sku = data.sku as string | null;
  const thumbnailUrl = data.thumbnailUrl as string | null;
  const isFirstProductRow = data.isFirstProductRow as boolean | undefined;

  if (isFirstProductRow === false) {
    return <div className={styles['empty-cell']} />;
  }

  return (
    <FlexRow className={styles['product-info']}>
      <FlexRow className={styles['product-image']}>
        {thumbnailUrl ? (
          <img alt={name ?? ''} className={styles['image-placeholder']} src={thumbnailUrl} />
        ) : (
          <span className={styles['no-image-placeholder']} />
        )}
      </FlexRow>
      <div>
        <Button className={styles['product-name']} onClick={() => openProductDetails(productId)} theme={THEME_CONSTANTS.link}>
          {name}
        </Button>
        <Text formattedMessageValues={{ sku: sku ?? '-' }} textType={TextType.Caption} value={messages.sku} />
      </div>
    </FlexRow>
  );
};
